import ModelDiagram from './ModelDiagram';
import { withI18n } from 'react-i18next';

export default withI18n()(ModelDiagram);
